/* eslint-disable camelcase */
import { createSelector } from 'reselect';
import moment from 'moment';

const selectTaxInterviews = createSelector(
  (state) => state.taxInterviews.payload,
  (payload) => {
    const { data, meta } = payload;

    if (!data || !data.length) {
      return { pageNumber: 1, perPage: 10, totalPages: 0, totalCount: 0, data: [] };
    }

    const {
      pageNumber: { current },
      perPage,
      totalPages,
      totalCount,
    } = meta;

    return {
      pageNumber: current,
      perPage,
      totalPages,
      totalCount,
      data: data.map(({ id, attributes, links: { downloadLink } }) => ({
        key: id,
        id,
        ...attributes,
        ...attributes.formData,
        bornOn:
          attributes.formData && attributes.formData.bornOn
            ? moment(attributes.formData.bornOn, 'YYYY-MM-DD')
            : null,
        isDraft: !attributes.formDataValid,
        downloadLink,
      })),
    };
  },
);

const selectTaxInterviewFormErrors = createSelector(
  (state) => state.taxInterviews.errors,
  (payload) => {
    let errors = {};

    if (payload && payload.status === 'CUSTOM-ERROR') {
      payload.data.errors.forEach(({ type, detail }) => {
        const field = type.split(':')[1];

        errors = {
          ...errors,
          [field]: detail,
        };
      });
    }

    return errors;
  },
);

const selectWithholdingCode = createSelector(
  (state) => state.taxInterviews.withholdingCode,
  (payload) => {
    const { data } = payload;

    if (!data || !data.id) {
      return { name: '', code: '' };
    }

    return { name: data.attributes.name, code: data.attributes.code };
  },
);

export default selectTaxInterviews;
export { selectTaxInterviewFormErrors, selectWithholdingCode };
